import type { ComponentProps } from 'react';

export const CheckIcon = (props: ComponentProps<'svg'>) => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M20 41.7L28.3909 54.2445L30.2341 57L31.8322 54.2445C39.8607 40 47.8133 23 59 23" stroke="currentColor"
          strokeWidth="6" strokeLinecap="round" strokeLinejoin="bevel" />
  </svg>
);